/*!
  Machina, by Koding Themes
  machina-animations.js
  https://kodingthemes.com
*/

//register plugins
gsap.registerPlugin(ScrollTrigger, ScrollToPlugin, ScrollSmoother);
let globalAnimation = {
  animationEffects: function (e) {
    // product page scroll effect media
    if (document.body.getAttribute("id") == "product") {
      var addHeight = 0;
      if (e.type == "shopify:section:load") {
        addHeight = document.querySelector("#product-info").offsetHeight;
      }
      if (e.type == "click") {
        addHeight = document.querySelector("#product-info").offsetHeight;
      }
      gsap.set("#product-media", {
        clearProps: true,
      });
      gsap.set("#product-info", {
        clearProps: true,
      });
      ScrollTrigger.matchMedia({
        "(min-width: 768px)": function minWidth768px() {
          var section = document.querySelector("#product-media");
          var anim = gsap.fromTo(
            section,
            {
              y: 10,
            },
            {
              duration: 0.5,
              y: 0,
              ease: "power4.out",
            }
          );
          const tl = gsap.timeline({
            scrollTrigger: {
              trigger: section,
              animation: anim,
              top: "top 0%",
              end: function end(self) {
                return (
                  "+=" +
                  (document.querySelector("#product-media").offsetHeight -
                    addHeight -
                    self.pin.offsetHeight)
                );
              },
              pin: "#product-info",
              onRefresh: function onRefresh(self) {
                return (self.pin.parentNode.style["float"] = "left");
              },
              pinSpacing: false,
              anticipatePin: 1,
              markers: false,
              scrub: 2,
            },
          });
          if(document.querySelector("#product-media-thumbnail") != null){
            const tlthumb = gsap.timeline({
            scrollTrigger: {
                trigger: section,
                animation: anim,
                top: "top 0%",
                end: function end(self) {
                  return (
                    "+=" +
                    (document.querySelector("#product-media").offsetHeight -
                      addHeight -
                      self.pin.offsetHeight)
                  );
                },
                pin: "#product-media-thumbnail",
                onRefresh: function onRefresh(self) {
                  return (self.pin.parentNode.style["float"] = "left");
                },
                pinSpacing: false,
                anticipatePin: 1,
                markers: false,
                scrub: 2,
              },
            });
          }
          var faqs = document.querySelectorAll(
            "#product-info .product-accordion-item, .product-details-tabs li a, .product-accordions-wrapper .accordion-title"
          );
          if (faqs.length > 0) {
            faqs.forEach(function (faq) {
              faq.addEventListener("click", function (e) {
                gsap.set("#product-info", {
                  clearProps: true,
                });
                tl.scrollTrigger.refresh();
              });
            });
          }
          var i = true;
          window.addEventListener("scroll", function () {
            var info = document.querySelector("#product-info");
            if (info != null && window.pageYOffset == 0 && i == true) {
              setTimeout(function () {
                tl.scrollTrigger.refresh();
              }, 50);
              i = false;
            } else {
              i = true;
            }
          });
        },
      }); // scrolltrigger for each section
      if (window.theme.sectionsAnimation == "true") {
        var sections = gsap.utils.toArray(".shopify-section");
        if (sections != null) {
          gsap.set(".shopify-section", {
            clearProps: true,
          });
          sections.forEach((section, i) => {
            if (
              section.querySelector("#product-form") == null &&
              section.querySelector(".shopify-section-group-footer-group") !=
                null &&
              section.querySelector("header") == null
            ) {
              var anim = gsap.fromTo(
                section,
                {
                  autoAlpha: 0,
                  y: 150,
                },
                {
                  duration: 1,
                  autoAlpha: 1,
                  y: 0,
                }
              );
              ScrollTrigger.create({
                trigger: section,
                animation: anim,
                start: "top 100%",
                end: "top 60%",
                markers: false,
                scrub: 1.5,
              });
            }
          });
        }
      }
    }
    //animate sections
    if (window.theme.sectionsAnimation == "true") {
      if (document.body.getAttribute("id") != "product") {
        if (document.body.getAttribute("id") != "collection") {
          var shopifySections = gsap.utils.toArray(".shopify-section");
          if (shopifySections != null) {
            gsap.set(".shopify-section", {
              clearProps: true,
            });
            gsap.set(shopifySections, {
              // className: "animation-applied-element",
            });
            var j = 0;
            shopifySections.forEach((sectionItem, i) => {
              sectionItem.classList.add("animation-applied-element");
              if (
                sectionItem.querySelector("header") == null &&
                sectionItem.querySelector(".main-footer") == null
              ) {
                j = j + 1;
                ScrollTrigger.matchMedia({
                  "(min-width: 768px)": function () {
                    var alpha = 0;
                    var offsetY = 150;
                    if (j < 2) {
                      if (e.type == "DOMContentLoaded") {
                        alpha = 1;
                        offsetY = 0;
                      }
                    }
                    var anim1 = gsap.fromTo(
                      sectionItem,
                      {
                        autoAlpha: alpha,
                        y: offsetY,
                      },
                      {
                        duration: 1,
                        autoAlpha: 1,
                        y: 0,
                      }
                    );
                    ScrollTrigger.create({
                      trigger: sectionItem,
                      animation: anim1,
                      start: "top 100%",
                      end: "top 50%",
                      markers: false,
                      scrub: 1.5,
                    });
                  },
                });
              }
            });
          }
        }
      }
    }
    // flicker debugger
    window.addEventListener("load", (event) => {
      var flickerSelectors = ["#product-info", ".product-grid", "#page-cart"];
      flickerSelectors.forEach(function (sl, index) {
        var item = document.querySelector(sl);
        // console.log("loading js", item);
        if (item != null) {
          item.style.setProperty("will-change", "transform, opacity");
        }
      });
    });
    window.addEventListener("load", (event) => {
      var productImgDsk = [".product-media-desktop-only"];
      productImgDsk.forEach(function (item, index) {
        var productItem = document.querySelector(item);
        // console.log("loading js", productItem);
        if (productItem != null) {
          productItem.style.setProperty("will-change", "transform, opacity");
        }
      });
    });
  },
  animationEffectsOnImages: function(){
    // scrolltrigger for each section img
    gsap.utils.toArray(".image-scale-animation img").forEach((target) => {
      gsap.set(target, {
        scale:1.1,
      });
      gsap.to(target,{scale:1,
        scrollTrigger:{
          trigger: target,
          start:'top 100%',
          end:'top 0%',
          markers:false,
          scrub:true,
          toggleActions:'play none none reverse',
        }
      });
    });
  }
};
document.addEventListener("DOMContentLoaded", function (e) {
  // globalAnimation.animationEffectsOnImages();
});
document.addEventListener("shopify:section:load", function (e) {
  // globalAnimation.animationEffectsOnImages();
});
document.addEventListener("shopify:section:unload", function (e) {
  // globalAnimation.animationEffectsOnImages();
});
document.addEventListener("shopify:section:reorder", function (e) {
  // globalAnimation.animationEffectsOnImages();
});
if (Shopify.designMode != true) {
  document.addEventListener("DOMContentLoaded", function (e) {
    globalAnimation.animationEffects(e);
  });
  document.addEventListener("shopify:section:load", function (e) {
    globalAnimation.animationEffects(e);
  });
  document.addEventListener("shopify:section:unload", function (e) {
    globalAnimation.animationEffects(e);
  });
  document.addEventListener("shopify:section:reorder", function (e) {
    globalAnimation.animationEffects(e);
  });
  document.addEventListener("DOMContentLoaded", function () {
    var checkbox = document.querySelector(".RecipientCheckbox");
    if (checkbox != null) {
      checkbox.addEventListener("click", function (e) {
        globalAnimation.animationEffects(e);
      });
    }
  });
}

//product card animations
var sectionAnimation = {
  cardsAnimation: function (e) {
    gsap.set(".product-card-item", {
      opacity: 0,
    });
    gsap.set(".product-card-item", {
      willChange: "transform",
    });
    gsap.set(".product-card-item.product-item-loaded", {
      clearProps: true,
    });
    ScrollTrigger.batch(".product-card-item", {
      onEnter: (batch) =>
        gsap.to(batch, {
          autoAlpha: 1,
          stagger: 0.2,
        }),
      markers: false,
      start: "top 85%",
    });
    ScrollTrigger.addEventListener("refreshInit", () =>
      gsap.set(".product-card-item", {
        opacity: 0,
      })
    );
  },
};

if (window.theme.sectionsAnimation == "true") {
  if (Shopify.designMode != true) {
    document.addEventListener(
      "shopify-collection-loader:init-product-grid",
      function (e) {
        var items = document.querySelectorAll(
          ".product-card-item.product-item-loaded"
        );
        if (items.length > 0) {
          var classAll = items[0].classList;
          classAll = classAll.value;
          classAll = classAll.replace("product-item-loaded", "");
          gsap.set(".product-card-item.product-item-loaded", {
            opacity: 0,
          });
          gsap.set(".product-card-item.product-item-loaded", {
            willChange: "transform",
          });
          ScrollTrigger.batch(".product-card-item.product-item-loaded", {
            onEnter: (batch) =>
              gsap.to(batch, {
                autoAlpha: 1,
                stagger: 0.2,
                className: classAll,
                //className: "product-card-item mb-0",
              }),
            markers: false,
            start: "top 85%",
          });
        }
        globalAnimation.animationEffects(e);
      }
    );

    document.addEventListener("DOMContentLoaded", function (e) {
      sectionAnimation.cardsAnimation(e);
    });
    document.addEventListener("shopify:section:load", function (e) {
      sectionAnimation.cardsAnimation(e);
    });
    document.addEventListener("shopify:section:unload", function (e) {
      sectionAnimation.cardsAnimation(e);
    });
    document.addEventListener("shopify:section:reorder", function (e) {
      sectionAnimation.cardsAnimation(e);
    });
    window.addEventListener("resize", function (e) {
      sectionAnimation.cardsAnimation(e);
    });
  }
}
//Theme editor JS
if (Shopify.designMode == true) {
  if (document.querySelector("#product-info") != null) {
    var infoWrapWidth = document.querySelector("#product-info").offsetWidth;
  }
  document.onscroll = function () {
    stickyProductThumbSection();
    stickyProductMediaSection();
  };
  document.addEventListener("shopify:section:load", function (e) {
    setTimeout(function(){
      var infoWrap = document.querySelector("#product-info");
      if(infoWrap != null){
        infoWrap.style.position = "relative";
        infoWrap.style.removeProperty("top");
        infoWrap.style.removeProperty("width");
      }
    }, 600);
  });
  function stickyProductMediaSection() {
    var mediaWrap = document.querySelector("#product-media");
    var infoWrap = document.querySelector("#product-info");
    if (mediaWrap != null && infoWrap != null) {
      var row = infoWrap.closest(".grid");
      if (window.innerWidth > 767) {
        var hm = mediaWrap.offsetHeight;
        var hi = infoWrap.offsetHeight;
        var diffmi = hm - hi;
        if (hm > hi) {
          infoWrap.style.position = "fixed";
          infoWrap.style.setProperty("width", infoWrapWidth + "px", "");
          var rect = mediaWrap.getBoundingClientRect();
          var scrolledMedia = -rect.top;
          console.log(scrolledMedia, diffmi);
          if (scrolledMedia >= diffmi) {
            infoWrap.style.position = "relative";
            row.style.setProperty("align-items", "end", "");
            infoWrap.style.removeProperty("top");
          } else if (scrolledMedia < diffmi) {
            infoWrap.style.position = "fixed";
            row.style.removeProperty("align-items");
            infoWrap.style.setProperty("top", "0", "");
          }
          if (Math.sign(scrolledMedia) == -1) {
            infoWrap.style.position = "relative";
            row.style.removeProperty("align-items");
            infoWrap.style.removeProperty("top");
            infoWrap.style.removeProperty("width");
          }
        }
      } else {
        infoWrap.style.position = "relative";
        row.style.removeProperty("align-items");
        infoWrap.style.removeProperty("top");
        infoWrap.style.removeProperty("width");
      }
    }
  }
  function stickyProductThumbSection() {
    var mediaWrap = document.querySelector("#product-media");
    var infoWrap = document.querySelector("#product-media-thumbnail");
    if (mediaWrap != null && infoWrap != null) {
      var row = infoWrap.closest(".grid");
      if (window.innerWidth > 767) {
        var hm = mediaWrap.offsetHeight;
        var hi = infoWrap.offsetHeight;
        var diffmi = hm - hi;
        if (hm > hi) {
          infoWrap.style.position = "fixed";
          infoWrap.style.setProperty("width", infoWrapWidth + "px", "");
          var rect = mediaWrap.getBoundingClientRect();
          var scrolledMedia = -rect.top;
          console.log(scrolledMedia, diffmi);
          if (scrolledMedia >= diffmi) {
            infoWrap.style.position = "relative";
            row.style.setProperty("align-items", "end", "");
            infoWrap.style.removeProperty("top");
          } else if (scrolledMedia < diffmi) {
            infoWrap.style.position = "fixed";
            row.style.removeProperty("align-items");
            infoWrap.style.setProperty("top", "0", "");
          }
          if (Math.sign(scrolledMedia) == -1) {
            infoWrap.style.position = "relative";
            row.style.removeProperty("align-items");
            infoWrap.style.removeProperty("top");
            infoWrap.style.removeProperty("width");
          }
        }
      } else {
        infoWrap.style.position = "relative";
        row.style.removeProperty("align-items");
        infoWrap.style.removeProperty("top");
        infoWrap.style.removeProperty("width");
      }
    }
  }
}
//Sticky header
document.addEventListener("DOMContentLoaded", function (e) {
  const navbar = document.querySelector(".header-infinite");
  if(navbar != null) {
    const headerHeight = navbar.getBoundingClientRect().height;
    // console.log(headerHeight);
  }
  window.addEventListener(
    "scroll",
    function (event) {
      var top = this.scrollY,
        left = this.scrollX;

      if (window.scrollY == 0) {
        //user scrolled to the top of the page
        if (navbar != null) {
          navbar.classList.remove("sticky");
        }
      }
    },
    false
  );
  const stickyNav = function (entries) {
    const [entry] = entries; //like entries[0]
    // console.log(entry);
    if (!entry.isIntersecting) {
      //header
      navbar.classList.add("sticky");
    } else {
      return;
    }
  };
  const headerObserver1 = new IntersectionObserver(stickyNav, {
    root: null,
    threshold: 0,
    rootMargin: "0px",
  });
  if (window.innerWidth > 767) {
    if (navbar != null) {
      headerObserver1.observe(navbar);
    }
  }
});
